import React, { Component, Fragment } from 'react'
import { Route, Switch } from 'react-router-dom';
import TabView from './TabView';
import UserPermissions from './UserPermissions';
import User from './User';
import Notifier from "~/components/Notifier/index.js";
import "./styles.scss";


class AuthRoute extends Component {
    render() {
        const { component: Component, isAccessable, claims, clientKey,...rest } = this.props;

        return (
            <Route exact={true} {...rest} render={(props) => (
                (isAccessable === true) ?
                    <Fragment>
                        <Component {...props} clientKey={clientKey} claims={claims} />
                    </Fragment>
                    : null
            )} />
        )
    }
}

class Settings extends Component {
    render() {
        const { info, claims, clientKey } = this.props;
        let isAccessable = info && info.UserTypeID === 1;
        return (
            <div className="settingsWrapper">
                <Fragment>
                    <Switch>
                        <AuthRoute exact path='/:clientKey/settings' component={TabView} clientKey={clientKey} isAccessable={isAccessable} claims={claims} />
                        <AuthRoute exact path='/:clientKey/settings/permissions/:userId' component={UserPermissions} clientKey={clientKey} isAccessable={isAccessable}/>
                        <AuthRoute exact path='/:clientKey/settings/addUser' component={User} clientKey={clientKey} isAccessable={isAccessable}/>
                        <AuthRoute exact path='/:clientKey/settings/editUser/:userId/:source' component={User} clientKey={clientKey} isAccessable={isAccessable}/>
                    </Switch>
                </Fragment>
            </div>
        )
    }
}


export default Settings